import Vue from "vue";

import { findInFormAnswer } from "./find_in_form_answer.js";
export class RadioFormInput {
  constructor() {
    this.type = "radio";
    this.data = {
      question: "",
      required: false,
      answers: [{ text: "" }, { text: "" }, { text: "" }],
    };
  }
}

export let RadioFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#radio-form-input-template",
  data: function () {
    return {
      trainee_answer: null,
    };
  },
  methods: {
    deleteAnswer: onDeleteAnswer,
    addAnswer: onAddAnswer,
    changed: onChanged,
  },
  created: function () {
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
    }
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});

function onAddAnswer() {
  this.input.data.answers.push({ text: "" });
}

function onDeleteAnswer(index) {
  this.input.data.answers.splice(index, 1);
}

function onChanged(e) {
  $(e.target)
    .siblings("[type=number]")
    .attr("placeholder", e.target.checked ? "1" : "0");
}
